import React from 'react';
import styles from './Contributions.module.css';
const ContributionsPage = () => {


    return (
        <>

<h1>cont</h1>
        </>
    )
}

export default ContributionsPage;

